import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from '../static/styles/Layouts.module.css';
import logoImg from '../static/img/eslLogo.png';

import { getUserProfile } from '../api/profile';

import homeIcon from '../static/img/Sidebar/iconHome.svg'
import dailyTaskIcon from '../static/img/Sidebar/iconDailyTasks.svg'
import tournamentIcon from '../static/img/Sidebar/iconTournaments.png'
import rewardsIcon from '../static/img/Sidebar/iconRewards.svg'
import leaderboardIcon from '../static/img/Sidebar/iconLeaderboard.svg'
import highlightsIcon from '../static/img/Sidebar/iconHighlights.svg'
import completedIcon from '../static/img/Sidebar/iconCompletedTasks.svg'
import settingsIcon from '../static/img/Sidebar/iconSettings.svg'
import defaultAvatarIcon from '../static/img/Sidebar/Avatar.png'

import instagramIcon from '../static/img/social/instagram.svg'
import facebookIcon from '../static/img/social/facebook.svg'
import youtubeIcon from '../static/img/social/youtube.svg'
import twitterIcon from '../static/img/social/twitter.svg'
import coinsIcon from '../static/img/Sidebar/iconCheckinCoins.png'
import DailyCheckin from '../views/DailyCheckin';
import { isAuthenticated } from '../api/auth';

const LayoutDesktop = ({ children, profileData }) => {
  const location = useLocation();
  const [isCheckinOpen, setIsCheckinOpen] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      const profile = await getUserProfile();
      setUserProfile(profile);
    };
    fetchUserProfile();
  }, []);

  const menuItems = [
    { icon: homeIcon, label: "Homepage", action: '/' },
    { icon: dailyTaskIcon, label: "Daily tasks", action: '/tasks' },
    { icon: tournamentIcon, label: "Tournaments", action: '/tournaments' },
    { icon: dailyTaskIcon, label: "Gaming Tasks", action: '/daily-gaming-tasks' }, // New entry
    { icon: rewardsIcon, label: "Rewards", action: '/rewards' },
    { icon: leaderboardIcon, label: "Leaderboard", action: '/leaderboard' },
    { icon: highlightsIcon, label: "Highlights", action: '/highlights' },
    { icon: completedIcon, label: "Completed tasks", action: '/completed' },
    // { icon: settingsIcon, label: "Settings", action: '/settings' },
  ];

  const socialLinks = [
    { icon: instagramIcon, url: '#', label: 'Instagram' },
    { icon: facebookIcon, url: '#', label: 'Facebook' },
    { icon: youtubeIcon, url: '#', label: 'YouTube' },
    { icon: twitterIcon, url: '#', label: 'Twitter' },
  ];

  const avatarUrl = userProfile?.profileImage || defaultAvatarIcon;
  let username = userProfile?.name || userProfile?.username || "Guest User";
  if (username.length > 7) {
    username = `${username.substring(0, 7)}...`;
  }

  const handleCheckIn = () => {
    if(isAuthenticated()) {
     setIsCheckinOpen(true);
    }
  }
  const handleNavigation = (action) => {
    if (typeof action === 'function') {
      action();
    } else if (typeof action === 'string') {
      navigate(action);
    }
  };

  return (
    <div className={styles.layout}>
      <div className={styles.layoutContainer}>
        <nav className={styles.sidebar}>
          <img src={logoImg} alt="ESL" className={styles.logo} />

          {/* Profile Section */}
          <Link to="/profile" className={styles.sidebarProfile}>
            <img src={avatarUrl} alt="" className={styles.profileImage}
            onError={e => { e.target.onerror = null; e.target.src = defaultAvatarIcon; }} />
            <div className={styles.profileInfo}>
              <span className={styles.userName}>{username}</span>
              <span className={styles.profileLabel}>Profile</span>
            </div>
          </Link>

          <ul className={styles.menuList}>
            {menuItems.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.action}
                  className={`${styles.navItem} ${
                    item.action === '/tournaments' 
                      ? (location.pathname === '/tournaments' || location.pathname.startsWith('/tournament/')) ? styles.navItemActive : ''
                      : location.pathname === item.action ? styles.navItemActive : ''
                  }`}
                >
                  <div className={styles.navItemContent}>
                    <img src={item.icon} alt="" className={styles.navIcon} />
                    <span className={styles.navText}>{item.label}</span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
          <div className={styles.rewardsContainer} onClick={() => { handleCheckIn() }} >
            <img src={coinsIcon} alt="" className={styles.goldPile} />
            <button className={styles.checkInButton}>
              Check in Rewards
              {/* <span className={styles.notificationBadge}>2</span> */}
            </button>
          </div>
        </nav>
        <DailyCheckin isOpen={isCheckinOpen} onClose={() => setIsCheckinOpen(false)} />

        <main className={styles.mainContent}>
          <div className={styles.mainContentInner}>
            {children}
            {(location.pathname !== '/puzzle-mania' && location.pathname !== '/space-football') && (
              <footer className={styles.footer}>
                <div className={styles.footerLeft}>
                  <p className={styles.footerText}>
                    Unleash your e-sports potential with Jazz ESL
                    <br />
                    © 2025 All Rights Reserved
                  </p>
                  <img src={logoImg} alt="ESL" className={styles.footerLogo} />
                </div>
                <div className={styles.footerRight}>
                  <p className={styles.followUsText}>Follow Us</p>
                  <div className={styles.socialIcons}>
                    {socialLinks.map((social) => (
                      <a
                        key={social.label}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={social.icon}
                          alt={social.label}
                          className={styles.socialIcon}
                        />
                      </a>
                    ))}
                  </div>
                </div>
              </footer>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default LayoutDesktop;